import { Drawer } from '@mui/material';
import React, { useState } from 'react';
import CenterTab from './CenterTab';
import ConfigurationTab from './ConfigurationTab';

const TABS = {
  CENTER: 'center',
  CONFIG: 'configuration',
};

export default function NotificationCenter({
  open,
  onClose,
  onGoBack,
  notifications,
  additionalConfiguration,
  channelsState,
  onChannelsStateChange,
  onPerformAction,
  onMarkAllAsRead,
  onOpenUpdateProfile,
  onOpenVerificationDialog,
  person,
  loading,
  hasNextPage,
  forwardRef,
}) {
  const [tab, setTab] = useState(TABS.CENTER);

  return (
    <Drawer anchor="right" open={open} onClose={onClose} sx={{ zIndex: 1300 }}>
      {tab === TABS.CENTER && (
        <CenterTab
          onClose={onClose}
          notifications={notifications}
          openConfiguration={() => setTab(TABS.CONFIG)}
          onMarkAllAsRead={onMarkAllAsRead}
          onPerformAction={onPerformAction}
          forwardRef={forwardRef}
          hasNextPage={hasNextPage}
          loading={loading}
        />
      )}
      {tab === TABS.CONFIG && (
        <ConfigurationTab
          onClose={onClose}
          onGoBack={() => {
            setTab(TABS.CENTER);
            onGoBack && onGoBack();
          }}
          additionalConfiguration={additionalConfiguration}
          person={person}
          channelsState={channelsState}
          onChannelsStateChange={onChannelsStateChange}
          onOpenUpdateProfile={onOpenUpdateProfile}
          onOpenVerificationDialog={onOpenVerificationDialog}
        />
      )}
    </Drawer>
  );
}
